import React, { Component } from 'react';
import '../Style/contact.css';

class Contact extends Component {

	render() {

		return (
			<div id="Contact" className="column-container gutter">

				<h3 className="center underline">Contact Me</h3>
				<form className="column-container">

					<label className="userinput"> <span classname="form-span"> Name: </span>
						<input className="name text" type="text"/>
						
					</label>

					<label className="userinput"> <span classname="form-span"> Email: </span>
						<input className="email text" type="email"/>
					</label>
					<label className="userinput"> <span classname="form-span"> Message: </span>
						<textarea className="message"/>
					</label>

					<button>send</button>

				</form>

				
			</div>
		)

	}

}

export default Contact;